import React from 'react';
import { Grid, Typography } from '@shore/react-gravity';
import { OnboardingSteps } from '../components/OnboardingSteps';

export function Home() {
  return (
    <div id="page-container" className="gv-flex gv-flex-col gv-w-full">
      <div id="app-content" className="gv-flex-1 gv-p-fluid gv-surface-dim">
        <Grid className="gv-gap-lg">
          <div>
            <div className="gv-flex gv-justify-between gv-items-center gv-gap-md">
              <Typography variant="heading" size="lg">
                Home
              </Typography>
            </div>
          </div>
          <Grid className="gv-gap-sm">
            <OnboardingSteps />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
